import { Injectable } from '@angular/core';

import { ApiService } from '../../../../../common/services/api.service';
import { environment } from 'src/environments/environment';
import { apiEndPoints } from '../../../../../common/constants/api-endpointsconstant';
import { ReportService } from 'src/app/reports/services/report.service';
import * as moment from 'moment';
import { map } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ReportInvestmentInventoryService {

  constructor(
    private apiServive: ApiService,
    private reportService: ReportService
  ) { }

  propertiesByNeighborhoodPayload: any = {
    pageSize: 20,
    pageNumber: 0,
    sort_order: null,
    year: null
  }

  projectsAndPropertiesPayload: any = {
    pageSize: 20,
    pageNumber: 0,
    sort_order: null,
    year: null
  }

  projectsPayload: any = {
    pageSize: 20,
    pageNumber: 0,
    sort_order: null,
    year: null
  }

  unitPayload: any = {
    pageSize: 20,
    pageNumber: 0,
    sort_order: null,
    year: null
  }

  unitTransactionPayload: any = {
    pageSize: 20,
    pageNumber: 0,
    sort_order: null,
    year: null
  }

  projectUnitPayload: any = {
    pageSize: 20,
    pageNumber: 0,
    sort_order: null,
    year: null
  }

  projectUnitTransactionPayload: any = {
    pageSize: 20,
    pageNumber: 0,
    sort_order: null,
    year: null
  }

  projectPropertiesPayload: any = {
    pageSize: 20,
    pageNumber: 0,
    sort_order: null,
    year: null
  }

  getOverviewSummary() {
    let queryParams = { ...this.reportService.queryParams };
    if (queryParams?.year) {
      queryParams.year = this.reportService.yearMaxValue(queryParams.year);
    }
    const changeParams = this.reportService.setfilterQueryParams(queryParams);
    const url: string = `${environment.miUrl}${apiEndPoints.inventoryOverviewReport}${changeParams}`;
    return this.apiServive.get(url, false);
  }

  getOverviewPropertySummary(uid:string) {
    let queryParams = { ...this.reportService.queryParams };
    if (queryParams?.year) {
      queryParams.year = this.reportService.yearMaxValue(queryParams.year);
    }
    const changeParams = this.reportService.setfilterQueryParams(queryParams);
    const url: string = `${environment.miUrl}${apiEndPoints.inventoryOverviewPropertyReport}${changeParams}&property_uid=${uid}`;
    return this.apiServive.get(url, false);
  }

  getOverviewProjectSummary(pId: any) {
    let queryParams = { ...this.reportService.queryParams };
    if (queryParams?.year) {
      queryParams.year = this.reportService.yearMaxValue(queryParams.year);
    }
    const changeParams = this.reportService.setfilterQueryParams(queryParams);
    const url: string = `${environment.miUrl}${apiEndPoints.inventoryOverviewProjectReport}${changeParams}&project_uid=${pId}`;
    return this.apiServive.get(url, false);
  }

  getPropertyAreaSummary(queryParams:any, uid:string) {
    if (queryParams?.year) queryParams.year = this.reportService.yearMaxValue(queryParams.year);
    if(queryParams.year == null){
      queryParams['year'] = new Date().getFullYear();
    }

    const changeParams = this.reportService.setfilterQueryParams(queryParams);
    const url: string = `${environment.miUrl}${apiEndPoints.inventoryAreaPropertyReport}${changeParams}&property_uid=${uid}`;
    return this.apiServive.get(url, false);
  }

  getProjectAreaSummary(pId: any) {
    let queryParams = { ...this.reportService.queryParams };
    if (queryParams?.year) {
      queryParams.year = this.reportService.yearMaxValue(queryParams.year);
    }
    const changeParams = this.reportService.setfilterQueryParams(queryParams);
    const url: string = `${environment.miUrl}${apiEndPoints.inventoryAreaProjectReport}${changeParams}&project_uid=${pId}`;
    return this.apiServive.get(url, false);
  }

  getInventoryPropertyGraphReport() {
    let queryParams = { ...this.reportService.queryParams };
    if (queryParams?.year) {
      queryParams.year = this.reportService.yearMaxValue(queryParams.year);
    }
    const changeParams = this.reportService.setfilterQueryParams(queryParams);
    const url: string = `${environment.miUrl}${apiEndPoints.inventoryPropertyGraphReport}${changeParams}`;
    return this.apiServive.get(url, false).pipe(
      map((res: any) => {
          if(res.status === 200 && res.data.length > 0 ){
            return res.data.map((val: any) => {
              let obj = {
                category: val.year.toString(),
                value: val.count
              }
              return obj
            })
          } else {
            return []
          }

      })
    );
  }



  getpropertiesByNeighborhood(payload: any) {
    let queryParams = { ...this.reportService.queryParams };
    if (queryParams?.year) {
      queryParams.year = this.propertiesByNeighborhoodPayload.year || this.reportService.yearMaxValue(queryParams.year);
    }
    const changeParams = this.reportService.setfilterQueryParams(queryParams);
    let offset = payload.pageNumber || 0
    let url: string = `${environment.miUrl}${apiEndPoints.inventoryNeighWisePropertiesReport}${changeParams}&limit=${payload?.pageSize}&offset=${offset}`;
    if (payload.sort_order) {
      url += `&sort_order=${payload.sort_order}`;
    }
    if(offset == 0){
      url += "&is_count=true"
    }
    this.propertiesByNeighborhoodPayload.pageNumber = offset;
    return this.apiServive.get(url, false);
  }

  getProjectsAndPropertiesReport(payload: any) {
    let queryParams = { ...this.reportService.queryParams };
    if (queryParams?.year) {
      queryParams.year = this.projectsAndPropertiesPayload.year || this.reportService.yearMaxValue(queryParams.year);
    }
    const changeParams = this.reportService.setfilterQueryParams(queryParams);
    let offset = payload.pageNumber || 0
    let url: string = `${environment.miUrl}${apiEndPoints.inventoryProjectsAndPropertiesReport}${changeParams}&limit=${payload?.pageSize}&offset=${offset}`;
    if (payload.sort_order) {
      url += `&sort_order=${payload.sort_order}`;
    }
    if(offset == 0){
      url += "&is_count=true"
    }
    this.projectsAndPropertiesPayload.pageNumber = offset;
    return this.apiServive.get(url, false);
  }

  getProjectsReport(payload: any) {
    let queryParams = { ...this.reportService.queryParams };
    if (queryParams?.year) {
      queryParams.year = this.projectsPayload.year || this.reportService.yearMaxValue(queryParams.year);
    }
    const changeParams = this.reportService.setfilterQueryParams(queryParams);
    let offset = payload.pageNumber || 0
    let url: string = `${environment.miUrl}${apiEndPoints.inventoryProjectReport}${changeParams}&limit=${payload?.pageSize}&offset=${offset}`;
    if (payload.sort_order) {
      url += `&sort_order=${payload.sort_order}`;
    }
    if(offset == 0){
      url += "&is_count=true"
    }
    this.projectsPayload.pageNumber = offset;
    return this.apiServive.get(url, false);
  }

  getUnitReport(payload: any, uid:string) {
    let queryParams = { ...this.reportService.queryParams };
    if (queryParams?.year) {
      queryParams.year = this.unitPayload.year || this.reportService.yearMaxValue(queryParams.year);
    }
    const changeParams = this.reportService.setfilterQueryParams(queryParams);
    let offset = payload.pageNumber || 0
    let url: string = `${environment.miUrl}${apiEndPoints.inventoryUnitReport}${changeParams}&property_uid=${uid}&limit=${payload?.pageSize}&offset=${offset}`;
    if (payload.sort_order) {
      url += `&sort_order=${payload.sort_order}`;
    }
    if(offset == 0){
      url += "&is_count=true"
    }
    this.unitPayload.pageNumber = offset;
    return this.apiServive.get(url, false);
  }

  getUnitProjectReport(payload: any, pId: any) {
    let queryParams = { ...this.reportService.queryParams };
    if (queryParams?.year) {
      queryParams.year = this.projectUnitPayload.year || this.reportService.yearMaxValue(queryParams.year);
    }
    const changeParams = this.reportService.setfilterQueryParams(queryParams);
    let offset = payload.pageNumber || 0
    let url: string = `${environment.miUrl}${apiEndPoints.inventoryUnitProjectReport}${changeParams}&project_uid=${pId}&limit=${payload?.pageSize}&offset=${offset}`;
    if (payload.sort_order) {
      url += `&sort_order=${payload.sort_order}`;
    }
    if(offset == 0){
      url += "&is_count=true"
    }
    this.projectUnitPayload.pageNumber = offset;
    return this.apiServive.get(url, false);
  }

  getProjectProperties(payload: any, pId: any) {
    let queryParams = { ...this.reportService.queryParams };
    if (queryParams?.year) {
      queryParams.year = this.projectPropertiesPayload.year || this.reportService.yearMaxValue(queryParams.year);
    }
    const changeParams = this.reportService.setfilterQueryParams(queryParams);
    let offset = payload.pageNumber || 0
    let url: string = `${environment.miUrl}${apiEndPoints.inventoryProjectpropertiesReport}${changeParams}&project_uid=${pId}&limit=${payload?.pageSize}&offset=${offset}`;
    if (payload.sort_order) {
      url += `&sort_order=${payload.sort_order}`;
    }
    if(offset == 0){
      url += "&is_count=true"
    }
    this.projectPropertiesPayload.pageNumber = offset;
    return this.apiServive.get(url, false);
  }

  getUnitTransactionProjectReport(payload: any, pId: any) {
    let queryParams = { ...this.reportService.queryParams };
    if (queryParams?.year) {
      queryParams.year = this.projectUnitTransactionPayload.year || this.reportService.yearMaxValue(queryParams.year);
    }
    const changeParams = this.reportService.setfilterQueryParams(queryParams);
    let offset = payload.pageNumber || 0
    let url: string = `${environment.miUrl}${apiEndPoints.inventoryUnitTransactionProjectReport}${changeParams}&project_uid=${pId}&limit=${payload?.pageSize}&offset=${offset}`;
    if (payload.sort_order) {
      url += `&sort_order=${payload.sort_order}`;
    }
    if(offset == 0){
      url += "&is_count=true"
    }
    this.projectUnitTransactionPayload.pageNumber = offset;
    return this.apiServive.get(url, false);
  }

  getUnitTransctionReport(payload: any, uid:string) {
    let queryParams = { ...this.reportService.queryParams };
    if (queryParams?.year) {
      queryParams.year = this.unitTransactionPayload.year || this.reportService.yearMaxValue(queryParams.year);
    }
    const changeParams = this.reportService.setfilterQueryParams(queryParams);
    let offset = payload.pageNumber || 0
    let url: string = `${environment.miUrl}${apiEndPoints.inventoryUnitTransctionReport}${changeParams}&property_uid=${uid}&limit=${payload?.pageSize}&offset=${offset}`;
    if (payload.sort_order) {
      url += `&sort_order=${payload.sort_order}`;
    }
    if(offset == 0){
      url += "&is_count=true"
    }
    this.unitTransactionPayload.pageNumber = offset;
    return this.apiServive.get(url, false);
  }

  downloadTransactionReport(type: string, user_id: number) {
    let url: string = `${environment.miUrl}${apiEndPoints.downloadTransactionReport}${this.reportService.filterQueryParams}&type=${type}&user_id=${user_id}`;
    return this.apiServive.get(url);
  }

  downloadExcelUrl() {
    return `${environment.miUrl}${apiEndPoints.downloadExcel}`;
  }





  formatOverViewSummary(data: any) {

    data['totalpropertiesVal'] = this.reportService.calcPercentage(data.prev_total_properties, data.total_properties);
    data['totalresidential'] = this.reportService.calcPercentage(data.prev_residential_units, data.residential_units);
    data['totalcommercial'] = this.reportService.calcPercentage(data.prev_commercial_units, data.commercial_units);
    data['untillDate'] = data.max_date ? moment.utc(data.max_date).local().format('DD MMM YYYY') : null;
    return data;
  }

  formatOverViewPropertySummary(data: any) {
    data['totalOccupancy'] = this.reportService.calcPercentage(data.prev_occupancy_rate, data.occupancy_rate);
    data['totalResidential'] = this.reportService.calcPercentage(data.prev_residential_units, data.residential_units);
    data['totalCommercial'] = this.reportService.calcPercentage(data.prev_commercial_units, data.commercial_units);
    data['untillDate'] = data.max_date ? moment.utc(data.max_date).local().format('DD MMM YYYY') : null;
    return data;
    // data['totalparking'] = this.reportService.calcPercentage(data.prev_parking_lots, data.parking_lots);
    // data['totalresidential'] = this.reportService.calcPercentage(data.prev_residential_units, data.residential_units);
    // data['totalcommercial'] = this.reportService.calcPercentage(data.prev_commercial_units, data.commercial_units);
    // data['untillDate'] = data.max_date ? moment.utc(data.max_date).local().format('DD MMM YYYY') : null;
    // return data;
  }

  formatOverViewProjectSummary(data: any) {

    data['totalProperties'] = this.reportService.calcPercentage(data.prev_total_properties, data.total_properties);
    data['totalresidential'] = this.reportService.calcPercentage(data.prev_residential_units, data.residential_units);
    data['totalcommercial'] = this.reportService.calcPercentage(data.prev_commercial_units, data.commercial_units);
    data['untillDate'] = data.max_date ? moment.utc(data.max_date).local().format('DD MMM YYYY') : null;
    return data;
  }


  downloadInvestmentReport(type:string, user_id:any, property_uid:string='', proj_uid:string=''){
    const filterQueryParams = this.reportService.filterQueryParams;
    const resultedQueryParams = filterQueryParams.replace(/&?year=\d{4}/, "");
    let url: string = `${environment.miUrl}${apiEndPoints.reportDownload}${resultedQueryParams}&type=${type}&user_id=${user_id}`;
    if(type === 'ir_inventory_neighwise_property') {
      url += `&year=${this.propertiesByNeighborhoodPayload.year}`
    }else if(type === 'ir_inventory_property') {
      url += `&year=${this.projectsAndPropertiesPayload.year}`
    }else if(type === 'ir_inventory_project') {
      url += `&year=${this.projectsPayload.year}`
    }
    if(property_uid) url += `&property_uid=${property_uid}`;
    if(proj_uid) url += `&project_uid=${proj_uid}`;
    return this.apiServive.get(url);
  }
}
